import { SvgBase } from "../svg.base";

export const GreenCheck: React.FC<{ size?: number }> = ({ size }) => (
    <SvgBase
        width={"" + (size || 64)}
        height={"" + (size || 64)}
        viewBox="0 0 64 64"
    >
        <g fill="none" fillRule="evenodd">
        <g>
            <g transform="translate(-148 -48) translate(148 48)">
                <circle cx="32" cy="32" r="32" fill="#00AB62" fillRule="nonzero"/>
                <g fill="#FFF">
                    <path d="M20.043 36.353L10.313 26.623 7 29.913 20.043 42.957 48.043 14.957 44.753 11.667z" transform="translate(4 4)"/>
                </g>
            </g>
        </g>
    </g>
    </SvgBase>
);


